<template>
  <div>
    <div v-if="withAction">
      <select-with-action
        v-model="filter"
        :name="name"
        :options="distanceTypesOptions"
        default-value="0"
        @change="emitTrack({[name]:filter})"
      />
    </div>
    <div
      v-else
      class="placeholder-label active"
    >
      <div class="form-group">
        <label
          class="hover"
          :for="`select_distance_${name}`"
        >
          <span>
            {{ $t('filter:distance') }} {{ $t('filter:distances.' + name) }}
          </span>
        </label>
        <b-form-select
          :id="`select_distance_${name}`"
          v-model="filter"
          class="form-control"
          :options="distanceTypes"
          :disabled="disableSelect"
        />
      </div>
    </div>
  </div>
</template>

<script>
import selectWithAction from 'components/SelectWithActions.vue';
import { BFormSelect } from 'bootstrap-vue';
import searchRedirect from 'mixins/composition/search/SearchFunctions';
import getNumberFormat from 'mixins/composition/NumberFormat';
import { gtmFilterMapping } from 'config/trackingParams';
import GtmTools from 'mixins/GtmTools';

export default {
  name: 'DistanceFilter',
  i18nOptions: { namespaces: 'filter' },
  components: { selectWithAction, BFormSelect },
  mixins: [GtmTools],
  props: {
    name: {
      required: true,
      type: String,
    },
    withAction: {
      type: Boolean,
      default: false,
    },
    // used to toggle between showing and hiding the seperator
    showSeperator: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, ctx) {
    const { formatNumber } = getNumberFormat(ctx);
    return { formatNumber, searchRedirect };
  },
  data() {
    return {
      // distanceTypes: {
      //   1: 'Fußnähe', 5: 'bis 5km', 10: 'bis 10km',
      // },
    };
  },
  computed: {
    filterCounter() {
      return (distance) => this.$store.getters.getAggregationTypeCount(this.name, distance);
    },
    disableSelect() {
      return (!parseInt(this.filterCounter(10), 10) > 0) || this.disabled === true;
    },
    filter: {
      get() {
        return this.$store.getters.getSearchFilter(this.name) || '0';
      },
      set(filterState) {
        const distanceString = gtmFilterMapping.distanceString[filterState || 0];
        const gtmString = gtmFilterMapping.distances[this.name] + distanceString;

        this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
        searchRedirect({ router: this.$router, filters: { [this.name]: filterState }, delay: 1000 });
      },
    },
    distanceTypesOptions() {
      const localeProp = `filter:options.distances.${this.name}_interval`;
      const distances = [
        { value: 0, text: `${this.$t(localeProp, { postProcess: 'interval', count: 0 })}` },
        {
          value: 1,
          text: `${this.$t(localeProp, { postProcess: 'interval', count: 1 })} ${this.filterCounter(1) > 0 ? `(${this.toggleSeperator(1)})` : ''}`,
          disabled: `${this.filterCounter(1) > 0 ? '' : 'disabled'}`,
        },
        {
          value: 5,
          text: `${this.$t(localeProp, { postProcess: 'interval', count: 5 })} ${this.filterCounter(5) > 0 ? `(${this.toggleSeperator(5)})` : ''}`,
          disabled: `${this.filterCounter(5) > 0 ? '' : 'disabled'}`,
        },
        {
          value: 10,
          text: `${this.$t(localeProp, { postProcess: 'interval', count: 10 })} ${this.filterCounter(10) > 0 ? `(${this.toggleSeperator(10)})` : ''}`,
          disabled: `${this.filterCounter(10) > 0 ? '' : 'disabled'}`,
        },
      ];
      return distances;
    },
    // used to render the selectbox on desktop
    distanceTypes() {
      const localeProp = `filter:desktopDistance.${this.name}_interval`;
      const distances = [
        { value: 0, text: `${this.$t(localeProp, { postProcess: 'interval', count: 0 })} ` },
        {
          value: 1,
          text: `${this.$t(localeProp, { postProcess: 'interval', count: 1 })} ${this.filterCounter(1) > 0 ? `(${this.toggleSeperator(1)})` : ''}`,
          disabled: `${this.filterCounter(1) > 0 ? '' : 'disabled'}`,
        },
        {
          value: 5,
          text: `${this.$t(localeProp, { postProcess: 'interval', count: 5 })} ${this.filterCounter(5) > 0 ? `(${this.toggleSeperator(5)})` : ''}`,
          disabled: `${this.filterCounter(5) > 0 ? '' : 'disabled'}`,
        },
        {
          value: 10,
          text: `${this.$t(localeProp, { postProcess: 'interval', count: 10 })} ${this.filterCounter(10) > 0 ? `(${this.toggleSeperator(10)})` : ''}`,
          disabled: `${this.filterCounter(10) > 0 ? '' : 'disabled'}`,
        },
      ];
      return distances;
    },
    // used to render the selectbox on desktop

  },
  // watch: {
  //   disableSelect(disable) {
  //     this.$store.state.disabledUi[this.name] = disable;
  //   },
  // },
  methods: {
    // shows a seperator between numbers if property showseperator is true takes in one param
    toggleSeperator(x) {
      return this.formatNumber(this.filterCounter(x), undefined, { useGrouping: this.showSeperator });
    },
  },
};
</script>

<style lang="scss" scoped>
.filterBoolText { padding-top: 20px; }
</style>
